import { render } from "./MiniIconLoader.vue?vue&type=template&id=67900cce&scoped=true"
const script = {}

import "./MiniIconLoader.vue?vue&type=style&index=0&id=67900cce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67900cce"]])

export default __exports__